export const MaxDisksPerController = 15;
